import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction, SetterMutation,
} from '@/shared/utils';
import {Vente, User, Client, Transporteur, Achat, BoisType, LongueursVente} from '@/models';
import {VenteService} from "@/xhttp/VenteService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class VenteFilter {

	date: DateFilter = new DateFilter();
	client: Client[] = [];
	boisType: BoisType[] = [];
	longueursVente: LongueursVente[] = [];
	volume: string = '';
	prixStere: string = '';
	transporteur: Transporteur[] = [];
	facture: string = '';
	totalParClient: boolean = false;
	totalParBoisType: boolean = false;
	totalParLongueur: boolean = false;
	totalDateDebut: string = '';
	totalDateFin: string = '';

	public clear(): void {
		this.date = new DateFilter();
		this.client = [];
		this.boisType = [];
		this.longueursVente = [];
		this.volume = '';
		this.prixStere = '';
		this.transporteur = [];
		this.facture = '';
		this.totalParClient = false;
		this.totalParBoisType = false;
		this.totalParLongueur = false;
		this.totalDateDebut = '';
		this.totalDateFin = '';
	}

	public toString(): string {
		return JSON.stringify({
			date	: this.date,
			client    : this.client.map(t => t.id),
			boisType    : this.boisType.map(t => t.id),
			longueursVente    : this.longueursVente.map(t => t.id),
			volume: this.volume,
			prixStere: this.prixStere,
			transporteur    : this.transporteur.map(t => t.id),
			totalParClient	: this.totalParClient,
			totalParBoisType	: this.totalParBoisType,
			totalParLongueur	: this.totalParLongueur,
			totalDateDebut	:	this.totalDateDebut,
			totalDateFin	:	this.totalDateFin,
		});

	}
}

class VenteState extends PaginatorFilterState<VenteFilter> {
	vente: Vente = null;
	ventes: ResultType<Vente> = null;
	public constructor() {
		super(new VenteFilter(), 'ventes', 'vente', 'date', AscDesc.DESC, 20)
	}
}

class VenteStore {

	@XHTTPService(() => Vente)
	private venteService: VenteService;
	private  _store: Store<any>;

	public state: VenteState = new VenteState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'ventes', 'vente'),
	};

	public actions = {
		...StandardAction<Vente, VenteState>(() => Vente, 'vente'),
		...PaginatorActionWithFilters<Vente, VenteState>(() => Vente, 'ventes', 'vente'),

		putMarkPaid(context: ActionContext<VenteState, any>, vente: Vente) {
			return instance.venteService.putMarkPaid(vente);
		},

		async getTotauxVentes(context: ActionContext<VenteState, any>): Promise<ResultType<Vente>> {
			const ventesTotauxResult = await instance.venteService.getTotauxVentes(storeVentesTotaux.state.filters.totalParClient, storeVentesTotaux.state.filters.totalParBoisType, storeVentesTotaux.state.filters.totalParLongueur, storeVentesTotaux.state.filters.totalDateDebut, storeVentesTotaux.state.filters.totalDateFin);
			context.commit('setVentes', ventesTotauxResult);
			return ventesTotauxResult;
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new VenteStore();
const storeVente = new Vuex.Store(instance);
instance.init(storeVente);

const instanceTotaux = new VenteStore();
export const storeVentesTotaux = new Vuex.Store(instanceTotaux);
instanceTotaux.init(storeVentesTotaux);

store.registerModule('vente', storeVente);
store.registerModule('ventesTotaux', storeVentesTotaux);
export default storeVente;
